import React from 'react';
import { object, string } from 'prop-types';
// import { Alert } from 'reactstrap';

const SuccessMessage = ({ message }) =>
  message ? (
    <div className="alert alert-success show" role="alert">
      {message}
    </div>
  ) : null;

SuccessMessage.propTypes = {
  message: string,
};

SuccessMessage.defaultProps = { message: undefined };

export default SuccessMessage;
